export type Theme = 'light' | 'dark' | 'system'

export type SailboatEnabled = boolean

export function getSystemTheme(): 'light' | 'dark' {
  if (typeof window === 'undefined') return 'light'
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

export function getStoredTheme(): Theme {
  if (typeof window === 'undefined') return 'system'
  return (localStorage.getItem('theme') as Theme) || 'system'
}

export function setStoredTheme(theme: Theme) {
  if (typeof window === 'undefined') return
  localStorage.setItem('theme', theme)
}

export function getEffectiveTheme(): 'light' | 'dark' {
  const stored = getStoredTheme()
  if (stored === 'system') {
    return getSystemTheme()
  }
  return stored
}

export function applyTheme(theme: 'light' | 'dark') {
  if (typeof window === 'undefined') return
  
  const root = document.documentElement
  root.classList.remove('light', 'dark')
  root.classList.add(theme)
  
  // Update meta theme-color
  const metaThemeColor = document.querySelector('meta[name="theme-color"]')
  if (metaThemeColor) {
    metaThemeColor.setAttribute('content', theme === 'dark' ? '#0B0F17' : '#FFFFFF')
  }
}

export function getStoredSailboatEnabled(): SailboatEnabled {
  if (typeof window === 'undefined') return true
  const stored = localStorage.getItem('sailboatEnabled')
  return stored === null ? true : stored === 'true'
}

export function setStoredSailboatEnabled(enabled: SailboatEnabled) {
  if (typeof window === 'undefined') return
  localStorage.setItem('sailboatEnabled', enabled.toString())
}

export function initializeTheme() {
  const effectiveTheme = getEffectiveTheme()
  applyTheme(effectiveTheme)
  
  // Listen for system theme changes
  if (typeof window !== 'undefined') {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    const handleChange = () => {
      const stored = getStoredTheme()
      if (stored === 'system') {
        applyTheme(getSystemTheme())
      }
    }
    
    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }
}
